'use client';
import { useRouter } from 'next/navigation';
import { hasInAppHistory } from '@/app/helpers/navigationDepth';

export const useHandleBackOrRedirect = (fallbackUrl: string = '/') => {
    const router = useRouter();
    return () => {
        // history.length 만으로는 부족하다 — 새 탭으로 링크를 직접 열어도 about:blank(1) +
        // 이 페이지(2)로 length 가 2가 되어 "뒤로 갈 수 있다"고 오판, router.back() 이
        // about:blank 로 빠진다(U6-11 체크아웃에서 실측). 이 탭에서 실제로 라우팅이
        // 일어난 적이 있을 때만 "뒤로"를 쓴다.
        if (window.history.length > 1 && hasInAppHistory()) {
            router.back();
        } else {
            router.replace(fallbackUrl);
        }
    };
};
